'use strict';

var _ = require('lodash');
var BootstrapFeaturesService = function BootstrapFeaturesService(App) {
  var featureApplicationPriority = ['REVENUE_OPTIMIZER', 'FARES_OPTIMIZER', 'FLEX_PRICING', 'DYNAMIC_AVAILABILITY'];
  function getFeatures() {
    return _.transform(App.features, function (result, n) {
      result[n.feature] = n.enable;
    }, {});
  }
  function getFeaturesWithActiveApp(features) {
    var appFeatures = _.cloneDeep(features);
    if (_.isEmpty(appFeatures)) {
      return appFeatures;
    }
    var activeApps = getAppsEnabledByPriority(appFeatures);
    _.each(featureApplicationPriority, function (feature) {
      appFeatures[feature] = _.includes(activeApps, feature);
    });
    return appFeatures;
  }
  function getAppsEnabledByPriority(features) {
    return _.chain(featureApplicationPriority).filter(function (featureApp) {
      return features && features[featureApp];
    }).value() || _.take(featureApplicationPriority);
  }
  function getFeaturesWithAppPriorityApplied() {
    var features = getFeatures();
    return getFeaturesWithActiveApp(features);
  }
  function getEnabledApps() {
    var features = getFeatures();
    return getAppsEnabledByPriority(features);
  }
  return {
    getFeaturesWithAppPriorityApplied: getFeaturesWithAppPriorityApplied,
    getFeatures: getFeatures,
    getEnabledApps: getEnabledApps
  };
};
BootstrapFeaturesService.$inject = ['App'];
module.exports = BootstrapFeaturesService;